module.exports = __webpack_public_path__ + "static/media/bg.8b7cc864.png";